/**
 * @desc 导出月度报表分组
 */
const URL = "/rantion-basics";
import http, { updateResponse } from "@/http";
export type Response = any;
export function request(
  params: API.basics.amazonDateRangeRules.exportAmzonDateRangeRulesInfo.Params,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/amazonDateRangeRules/exportAmzonDateRangeRulesInfo`, {
      method: "POST",
      params,

      ...options,
    }),
  );
}
